import { AddComplaintModel, Complaint8DNameSlimModel, ComplaintChartFilterOptions, ComplaintErrorCodeModel, ComplaintTableFilterOptions, CreateComplaint8DNameRequest, DataPartAnalysisResponse, DefectivePartAnalysisSupplierResponseModel, GetAll8dNamesResponse, GetAllComplaintPartGroupsResponse, GetAllComplaintsResponse, GetAllComplaintSupplierComplaintNumbersResponse, GetComplaintErrorCodesResponse, ImportHistoryResponse } from "../../../shared/generated";
import { PartChartsModel } from "../../../shared/models/part-charts.model";

export interface PartsState {
  complaints: GetAllComplaintsResponse | null;
  addComplaintModel?: AddComplaintModel;
  eightDNames: GetAll8dNamesResponse | null;
  partGroups: GetAllComplaintPartGroupsResponse | null;
  complaintSupplierComplaintNumbers: GetAllComplaintSupplierComplaintNumbersResponse | null;
  errorCodes: GetComplaintErrorCodesResponse | null;
  csvFile: object | null;
  excelFile: object | null;
  complainId?: number;
  hashValue?: string;
  partIdentNumber?: string;
  complaintsDetails?: any;
  sources: string[];
  charts: PartChartsModel;
  importFile?: Blob;
  complaintChartFilterOptions: ComplaintChartFilterOptions[];
  source?: string,
  supplierNumber?: string,
  activeErrorCodes?: ComplaintErrorCodeModel[],
  rootCauses?: Complaint8DNameSlimModel[],
  defectivePartAnalysisSupplier?: DefectivePartAnalysisSupplierResponseModel,
  errorCode: string,
  errorLabelGerman: string,
  errorDescriptionGerman: string,
  errorLabelEnglish: string,
  errorDescriptionEnglish: string,
  errorCodeName?: string,
  isActive?: boolean,
  createComplaint8DNameRequest?: CreateComplaint8DNameRequest,
  tab?: string,
  data?: string,
  files?: Array<Blob>,
  transferData?: boolean,
  id?: number,
  defectivePartAnalysisSupplierId?: number,
  filesForDelete?: string[],
  filename?: string,
  complaintTableFilterOptions: ComplaintTableFilterOptions[];
  file?: any;
  data4D8D?: any;
  partAnalysisData?: DataPartAnalysisResponse;
  downloadedFiles: { [requestId: string]: any };
  supplierComplaintNumber?: string;
  complaintImportHistoryResponse: ImportHistoryResponse | null;
  diagnosticProtocols?: any[];
}

export const initialState: PartsState = {
  complaints: null,
  eightDNames: null,
  partGroups: null,
  complaintSupplierComplaintNumbers: null,
  errorCodes: null,
  csvFile: null,
  excelFile: null,
  complaintsDetails: {},
  sources: [],
  complaintChartFilterOptions: [],
  complaintTableFilterOptions: [],
  charts: {
    chartCustomerDecisionPerShipmentYear: {
      isLoading: false
    },
    chartCustomerDecisionPerShipmentMonth: {
      isLoading: false
    },
    chartSupplierFeedbackPerShipmentYear: {
      isLoading: false
    },
    chartSupplierFeedbackPerShipmentMonth: {
      isLoading: false
    },
    chartSupplierFeedbackPerRepairYear: {
      isLoading: false
    },
    chartSupplierFeedbackPerRepairMonth: {
      isLoading: false
    },
    chartSupplierFeedbackPerPartProductionYear: {
      isLoading: false
    },
    chartSupplierFeedbackPerPartProductionMonth: {
      isLoading: false
    },
    chartCustomerDecisionPerPartProductionYear: {
      isLoading: false
    },
    chartCustomerDecisionPerPartProductionMonth: {
      isLoading: false
    },
    chartEightDNamePerPartProductionMonth: {
      isLoading: false
    },
    chartPartProductionYearPerSupplierNumber: {
      isLoading: false
    },
    chartRepairCountryPerSupplierNumber: {
      isLoading: false
    },
    chartCustomerDecisionPerVehicleModel: {
      isLoading: false
    },
    chartCustomerDecisionPerReturnCountry: {
      isLoading: false
    },
  },
  errorCode: '',
  errorLabelGerman: '',
  errorDescriptionGerman: '',
  errorLabelEnglish: '',
  errorDescriptionEnglish: '',
  downloadedFiles: {},
  complaintImportHistoryResponse: null,
  diagnosticProtocols: []
}
